export default {
    methods: {
        sortMapIcons(val) {
            if (!val) return false;
            
            let vm = this;
            const path = (this.baseUrl ? this.baseUrl : '') + '/assets/icons/';
            const ext = '.png';

            let garageFitters = val.filter((fitter) => {
                return fitter.mobile == 0;
            });

            let i = 1;

            _.forEach(garageFitters, function(fitter, index) {
                fitter['mapIconNumber'] = ((vm.view == 'fitters' || vm.view == 'fittedNationally') ? _toStr(i) : '.');
                fitter['mapIconSymbol'] = path + ((vm.view == 'fitters' || vm.view == 'fittedNationally') ? 'fitter' : 'tyre') + ext;
                fitter['mapIconColour'] = 'white';

                if(fitter.cal_account_number == 'CALHALF') {
                    fitter['mapIconSymbol'] = path + ((vm.view == 'fitters' || vm.view == 'fittedNationally') ? 'halfords' : 'tyre') + ext;
                    fitter['mapIconColour'] = 'orange';
                }
                else if(fitter.cal_account_number == 'CALFIT' || fitter.featured == true) {
                    fitter['mapIconSymbol'] = path + ((vm.view == 'fitters' || vm.view == 'fittedNationally') ? 'protyre' : 'tyre') + ext;
                }
                else if(fitter.cal_account_number == 'CALAAPRE') {
                    fitter['mapIconSymbol'] = path + ((vm.view == 'fitters' || vm.view == 'fittedNationally') ? 'aa-prestige' : 'tyre') + ext;
                    fitter['mapIconColour'] = 'black';
                }
                i++;
            });
        }
    }
};